app.service('productCardConfig',function(pageConfig) {
	function getData(){
		return pageConfig.getData('productCard');
	}
	
	return {
		getData: getData
	};
});
